import { FakeAgents } from "./agents/Agents";
import { FakeGuards } from "./guardrails/Guarddrails";
import { FakeKnowledgeBase } from "./kb/KnowledgeBase";
import { FakeTeams } from "./teams/Teams";
import { FakeTools } from "./tools/Tools";

export const FakeData = {
  FakeAgents,
  FakeTeams,
  FakeTools,
  FakeKnowledgeBase,
  FakeGuards,
};
